import React, { useEffect, useState } from 'react';
import './App.css';

const buildPrototypeUrl = () => {
  const hash = window.location.hash || '';
  return `/shengyuui.html${hash}`;
};

function App() {
  const [prototypeUrl, setPrototypeUrl] = useState(buildPrototypeUrl);

  useEffect(() => {
    document.title = '声屿 - AI 声音陪伴';
    document.documentElement.lang = 'zh-CN';
    document.documentElement.removeAttribute('data-theme');

    const onHashChange = () => setPrototypeUrl(buildPrototypeUrl());
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);

  return (
    <main className="shengyu-web-shell" aria-label="声屿 Web 端">
      <iframe
        className="shengyu-web-frame"
        title="声屿 App 交互视觉稿"
        src={prototypeUrl}
        allow="web-share; clipboard-write; identity-credentials-get"
      />
    </main>
  );
}

export default App;
